export const convertLocalToUTCDate = (localDate: Date): Date => {
  // Get the local time zone offset in minutes and convert it to milliseconds
  const timeZoneOffset = localDate.getTimezoneOffset() * 60000; // offset in milliseconds
  // Subtract the time zone offset from the local date to get the UTC date
  const utcDate = new Date(localDate.getTime() - timeZoneOffset);
  return utcDate;
};
